import { gql } from '@apollo/client';

export const RESEND_TEMPORARY_PASSWORD = gql`
  query resendTemporaryPassword($data: ResendTemporaryPasswordInput!) {
    resendTemporaryPassword(data: $data)
  }
`;
